import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  const menuItems = [{
    id: 'problem',
    label: 'Problem'
  }, {
    id: 'solution',
    label: 'Lösung'
  }, {
    id: 'compliance',
    label: 'Compliance'
  }, {
    id: 'features',
    label: 'Funktionen'
  }, {
    id: 'benefits',
    label: 'Vorteile'
  }, {
    id: 'pricing',
    label: 'Preise'
  }, {
    id: 'faq',
    label: 'FAQ'
  }];
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="flex justify-between items-center h-16" data-id="element-67">
          {/* Logo */}
          <div className="flex items-center" data-id="element-68">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nHh5FC22HMTcqGd6hdU9hd/LegalLama_Icon_Logo_458-458.png" alt="LegalLama Logo" className="h-16 w-auto" data-id="element-69" />
            <span className="ml-3 text-2xl font-bold text-gray-900" data-id="element-70">
              Legallama
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-71">
            {menuItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap" data-id="element-72">
                {item.label}
              </button>)}
          </nav>

          {/* Desktop CTA Button */}
          <a href="mailto:hello@legallama.de?subject=Ich%20wünsche%20eine%20Demo%20zu%20Legallama" className="hidden lg:block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap" data-id="element-73">
            Kostenlose Demo buchen
          </a>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-gray-700 hover:text-blue-600 transition-colors" aria-label="Toggle menu" data-id="element-74">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-75" /> : <MenuIcon className="w-6 h-6" data-id="element-76" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <div className="lg:hidden py-4 border-t border-gray-200" data-id="element-77">
            <nav className="flex flex-col gap-4" data-id="element-78">
              {menuItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors py-2" data-id="element-79">
                  {item.label}
                </button>)}
              <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors mt-2" data-id="element-80">
                Kostenlose Demo buchen
              </button>
            </nav>
          </div>}
      </div>
    </header>;
}